export interface Category {
  id: string;
  name: string;
  icon: string;
  description: string;
  items: CategoryItem[];
}

export interface CategoryItem {
  id: string;
  name: string;
  image: string;
  description: string;
  tags: string[];
}

export const categories: Category[] = [
  {
    id: 'tech',
    name: '科技研发',
    icon: 'ri-cpu-line',
    description: '南宫集团深耕科技研发领域，拥有多项核心技术专利，为全球客户提供智能化解决方案。',
    items: [
      {
        id: 'tech-1',
        name: '智能云平台',
        image: 'https://readdy.ai/api/search-image?query=Modern%20cloud%20computing%20platform%20with%20clean%20server%20infrastructure%2C%20futuristic%20data%20center%20design%2C%20soft%20blue%20and%20white%20tones%2C%20minimalist%20tech%20aesthetic%2C%20professional%20corporate%20style%2C%208k%20render%20quality&width=800&height=600&seq=category-tech-01&orientation=landscape',
        description: '基于云端架构的企业级智能管理平台，支持多端协同、数据实时同步，帮助企业实现数字化转型。',
        tags: ['云计算', '企业服务', '数据管理'],
      },
      {
        id: 'tech-2',
        name: 'AI大数据分析',
        image: 'https://readdy.ai/api/search-image?query=Artificial%20intelligence%20data%20analytics%20dashboard%20with%20flowing%20charts%20and%20graphs%2C%20clean%20modern%20interface%2C%20warm%20white%20background%2C%20professional%20corporate%20style%2C%20minimalist%20design%2C%20abstract%20data%20visualization&width=800&height=600&seq=category-tech-02&orientation=landscape',
        description: '运用人工智能算法深度挖掘数据价值，为企业决策提供精准的数据支撑与预测分析。',
        tags: ['人工智能', '数据分析', '商业智能'],
      },
      {
        id: 'tech-3',
        name: '物联网解决方案',
        image: 'https://readdy.ai/api/search-image?query=Internet%20of%20things%20smart%20devices%20connected%20network%2C%20modern%20industrial%20IoT%20concept%2C%20clean%20white%20background%2C%20professional%20tech%20aesthetic%2C%20minimalist%20design%2C%20warm%20lighting%2C%20corporate%20style&width=800&height=600&seq=category-tech-03&orientation=landscape',
        description: '全面的物联网生态解决方案，涵盖智能家居、智慧城市、工业物联网等多个应用场景。',
        tags: ['物联网', '智能硬件', '智慧城市'],
      },
    ],
  },
  {
    id: 'invest',
    name: '产业投资',
    icon: 'ri-funds-line',
    description: '凭借雄厚的资本实力和专业的投资团队，南宫集团在多个战略性产业进行了前瞻性布局。',
    items: [
      {
        id: 'invest-1',
        name: '新兴产业基金',
        image: 'https://readdy.ai/api/search-image?query=Modern%20financial%20investment%20concept%20with%20growth%20charts%20and%20minimalist%20office%20setting%2C%20clean%20white%20background%2C%20professional%20corporate%20style%2C%20warm%20golden%20accents%2C%20elegant%20aesthetic&width=800&height=600&seq=category-invest-01&orientation=landscape',
        description: '专注于新能源、生物医药、人工智能等新兴产业领域的股权投资与孵化培育。',
        tags: ['股权投资', '新兴产业', '基金管理'],
      },
      {
        id: 'invest-2',
        name: '不动产投资',
        image: 'https://readdy.ai/api/search-image?query=Modern%20commercial%20real%20estate%20architecture%20with%20clean%20lines%2C%20elegant%20building%20design%2C%20warm%20natural%20lighting%2C%20professional%20corporate%20style%2C%20minimalist%20aesthetic%2C%20white%20and%20beige%20tones&width=800&height=600&seq=category-invest-02&orientation=landscape',
        description: '覆盖商业地产、产业园区、长租公寓等多元化的不动产投资与管理体系。',
        tags: ['商业地产', '产业园区', '资产管理'],
      },
    ],
  },
  {
    id: 'trade',
    name: '国际贸易',
    icon: 'ri-global-line',
    description: '南宫集团国际贸易网络遍布全球，为合作伙伴提供高效、可靠的跨境贸易综合服务。',
    items: [
      {
        id: 'trade-1',
        name: '跨境供应链',
        image: 'https://readdy.ai/api/search-image?query=Global%20supply%20chain%20logistics%20network%20concept%20with%20shipping%20containers%20and%20world%20map%2C%20clean%20modern%20design%2C%20warm%20white%20background%2C%20professional%20corporate%20style%2C%20minimalist%20aesthetic&width=800&height=600&seq=category-trade-01&orientation=landscape',
        description: '整合全球优质供应商资源，打造端到端的跨境供应链服务体系，降低贸易成本。',
        tags: ['供应链', '跨境贸易', '物流管理'],
      },
      {
        id: 'trade-2',
        name: '国际会展服务',
        image: 'https://readdy.ai/api/search-image?query=International%20trade%20exhibition%20hall%20with%20modern%20booths%20and%20elegant%20design%2C%20clean%20white%20background%2C%20professional%20corporate%20style%2C%20warm%20lighting%2C%20minimalist%20aesthetic&width=800&height=600&seq=category-trade-02&orientation=landscape',
        description: '承办各类国际经贸展会与商务对接活动，促进中外企业间的交流与合作。',
        tags: ['会展服务', '商务对接', '国际合作'],
      },
    ],
  },
];